// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CustomScroll__container-fdeeea {
  --scrollbar-bg-color: var(--base-10);
  --scrollbar-thumb-color: var(--base-70_30);
  overscroll-behavior: contain;
}

/* Works on Safari, Safari iOS */
.CustomScroll__container-fdeeea::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  background-color: var(--scrollbar-bg-color);
}

.CustomScroll__container-fdeeea::-webkit-scrollbar-thumb {
  background: var(--scrollbar-thumb-color);
  border-radius: 10px;
}

/* Works on Firefox, Chrome, Edge, Opera */
@supports (scrollbar-color: #888 #f1f1f1) {
  .CustomScroll__container-fdeeea {
    scrollbar-color: var(--scrollbar-thumb-color) var(--scrollbar-bg-color);
    scrollbar-width: thin;
  }
}`, "",{"version":3,"sources":["webpack://./../../packages/ui-kit/src/CustomScroll/CustomScroll.styles.m.css"],"names":[],"mappings":"AAAA;EACE,oCAAA;EACA,0CAAA;EACA,4BAAA;AACF;;AACA,gCAAA;AACA;EACE,UAAA;EACA,WAAA;EACA,2CAAA;AAEF;;AACA;EACE,wCAAA;EACA,mBAAA;AAEF;;AACA,0CAAA;AACA;EACE;IACE,uEAAA;IACA,qBAAA;EAEF;AACF","sourcesContent":[".container {\n  --scrollbar-bg-color: var(--base-10);\n  --scrollbar-thumb-color: var(--base-70_30);\n  overscroll-behavior: contain;\n}\n/* Works on Safari, Safari iOS */\n.container::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n  background-color: var(--scrollbar-bg-color);\n}\n\n.container::-webkit-scrollbar-thumb {\n  background: var(--scrollbar-thumb-color);\n  border-radius: 10px;\n}\n\n/* Works on Firefox, Chrome, Edge, Opera */\n@supports (scrollbar-color: #888 #f1f1f1) {\n  .container {\n    scrollbar-color: var(--scrollbar-thumb-color) var(--scrollbar-bg-color);\n    scrollbar-width: thin;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `CustomScroll__container-fdeeea`
};
module.exports = ___CSS_LOADER_EXPORT___;
